export default __webpack_public_path__ + "static/media/credit-cards.53f76215.svg";